"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityMonitoringRuleOptions = void 0;
/**
 * Options on rules.
 */
class SecurityMonitoringRuleOptions {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return SecurityMonitoringRuleOptions.attributeTypeMap;
    }
}
exports.SecurityMonitoringRuleOptions = SecurityMonitoringRuleOptions;
/**
 * @ignore
 */
SecurityMonitoringRuleOptions.attributeTypeMap = {
    complianceRuleOptions: {
        baseName: "complianceRuleOptions",
        type: "CloudConfigurationComplianceRuleOptions",
    },
    decreaseCriticalityBasedOnEnv: {
        baseName: "decreaseCriticalityBasedOnEnv",
        type: "boolean",
    },
    detectionMethod: {
        baseName: "detectionMethod",
        type: "SecurityMonitoringRuleDetectionMethod",
    },
    evaluationWindow: {
        baseName: "evaluationWindow",
        type: "SecurityMonitoringRuleEvaluationWindow",
        format: "int32",
    },
    hardcodedEvaluatorType: {
        baseName: "hardcodedEvaluatorType",
        type: "SecurityMonitoringRuleHardcodedEvaluatorType",
    },
    impossibleTravelOptions: {
        baseName: "impossibleTravelOptions",
        type: "SecurityMonitoringRuleImpossibleTravelOptions",
    },
    keepAlive: {
        baseName: "keepAlive",
        type: "SecurityMonitoringRuleKeepAlive",
        format: "int32",
    },
    maxSignalDuration: {
        baseName: "maxSignalDuration",
        type: "SecurityMonitoringRuleMaxSignalDuration",
        format: "int32",
    },
    newValueOptions: {
        baseName: "newValueOptions",
        type: "SecurityMonitoringRuleNewValueOptions",
    },
    thirdPartyRuleOptions: {
        baseName: "thirdPartyRuleOptions",
        type: "SecurityMonitoringRuleThirdPartyOptions",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=SecurityMonitoringRuleOptions.js.map